export enum EventLogType {
  Admin_Login = 'Admin_Login',
  Admin_Logout = 'Admin_Logout',
  Admin_User_Added = 'Admin_User_Added',
  Admin_User_Deactivated = 'Admin_User_Deactivated',
  Admin_User_Activated = 'Admin_User_Activated',
  Admin_Role_Added = 'Admin_Role_Added',
  Admin_Role_Removed = 'Admin_Role_Removed',
}

export const EventLogTypes = Object.values(EventLogType);
